module.exports = __webpack_public_path__ + "static/bg-sidebar-health-and-fitness-1bfe46d10ea3e10a35c7727ed4976fc5.svg";